/* @flow */

import { DIRETORIO_IMAGENS_TEMA } from '../utils/constants';

export default (mensagem: string) => `
<img
    src="${DIRETORIO_IMAGENS_TEMA}/misc/caixa-vazia.png"
    class="img-fluid"
    style="display: block;margin: auto;">
<h5 class="m-portlet__head-text text-center">
    ${mensagem}
</h5>
`;
